const meetingStatuses = Object.freeze({
  created: 0,
  mandatesCreated: 1,
  invitationSent: 2,
  completed: 3,
  canceled: 4,
  started: 5,
  invitationReadyToBeSent: 6,
  invitationInProgress: 7,
  pvReadyToBeSent: 8,
  pvInProgress: 9,
  pvSent: 10,
});

export { meetingStatuses };
